module.exports = __webpack_public_path__ + "img/BG.1355d3ff.svg";